import './index.css';
import { make } from '../../../utils';

import { IconStretch, IconPicture } from '@codexteam/icons';

export default class ImageBlock {

  static get isReadOnlySupported() {
	return true;
  }
  static get toolbox() {
	return {
	  icon: IconPicture,
	  title: 'Image',
	};
  }

  static get tunes() {
	return [
	  {
		name: 'stretched',
		label: 'Stretch Image',
		icon: IconStretch,
	  }
	];
  }
  static get sanitize() {
	return {
	  url: {},
	  stretched: {}
	};
  }

  constructor({ data, api, readOnly, block, config }) {
	this.api = api;
	this.readOnly = readOnly;
	this.block = block;
	this.config = config

	this.nodes = {
	  wrapper: null,
	  inputContainer: null,
	  inputDropzone: null,
	  inputDropzonePicture: null,
	  inputDropzoneText: null,
	  inputElement: null,

	  imageContainer: null,
	  imageElement: null,
	};

	this._data = {
	  url: '',
	  stretched: false
	};
	this.data = data;
  }

  get CSS() {
	return {
	  baseClass: this.api.styles.block,

	  /**
	   * Tool's classes
	   */
	  wrapper: 'image-block',
	  inputContainer: 'upload-container',
	  inputDropzone: 'upload-dropzone',
	  inputDropzonePicture: 'upload-dropzone-picture',
	  inputDropzoneText: 'upload-dropzone-text',
	  inputElement: 'upload-element',

	  imageContainer: 'image-container',
	  imageElement: 'image-element',
	};
  };

  render() {

	let wrapper = make('div', [this.CSS.baseClass, this.CSS.wrapper]);
	this.nodes.wrapper = wrapper;

	let inputContainer = make('label', [this.CSS.inputContainer, this.data.alignment], { for: this.block.id });
	this.nodes.inputContainer = inputContainer;

	let inputElement = make('input', [this.CSS.inputElement], { id: this.block.id, type: 'file' });
	let inputDropzone = make('span', [this.CSS.inputDropzone]);
	let inputDropzonePicture = make('span', [this.CSS.inputDropzonePicture])
	inputDropzonePicture.innerHTML = `
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
	  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
	</svg>`;
	let inputDropzoneText = make('span', [this.CSS.inputDropzoneText])
	inputDropzoneText.innerHTML = this.api.i18n.t('Click to upload');
	inputDropzone.appendChild(inputDropzonePicture);
	inputDropzone.appendChild(inputDropzoneText);

	inputContainer.appendChild(inputDropzone);
	inputContainer.appendChild(inputElement);

	let imageContainer = make('div', [this.CSS.imageContainer]);
	this.nodes.imageContainer = imageContainer;
	this.setTune("stretched", this.data.stretched);

	let imageElement = make('img', [this.CSS.imageElement]);
	this.nodes.imageElement = imageElement;

	imageElement.onload = () => {
	  imageContainer.appendChild(imageElement);
	  wrapper.appendChild(imageContainer);

	  inputContainer.remove();
	};

	imageElement.onerror = (e) => {
	  console.error(e);
	};


	if (this.data.url) {
	  wrapper.appendChild(imageContainer);
	  imageElement.src = this.data.url;
	} else {
	  wrapper.appendChild(inputContainer);

	  inputElement.onchange = (e) => {
		const file = e.target.files[0];

		this.onDropHandler(file)
		  .then(data => {
			this.data = data;
		  });
	  };
	}

	return wrapper;
  }

  validate(savedData) {
	return savedData.url;
  }

  save() {
	if (!this.nodes.imageElement) {
	  return this.data;
	}

	return Object.assign(this.data, {
	  url: this.nodes.imageElement.src,
	});
  }

  onDropHandler(file) {
	const reader = new FileReader();

	reader.readAsDataURL(file);

	return new Promise(resolve => {
	  reader.onload = (event) => {
		resolve({
		  url: event.target.result,
		  name: file.name,
		  stretched: false
		});
	  };
	});
  }

  static get pasteConfig() {
	return {
	  tags: [
		{
		  img: { src: true },
		},
	  ],
	  patterns: {
		image: /https?:\/\/\S+\.(gif|jpe?g|tiff|png|webp)$/i,
	  },
	  files: {
		mimeTypes: ['image/*'],
	  },
	};
  }
  onPaste(event) {
	switch (event.type) {
	  case 'tag': {
		const img = event.detail.data;

		this.data = {
		  url: img.src,
		};
		break;
	  }

	  case 'pattern': {
		const { data: text } = event.detail;

		this.data = {
		  url: text,
		};
		break;
	  }

	  case 'file': {
		const { file } = event.detail;

		this.onDropHandler(file)
		  .then(data => {
			this.data = data;
		  });

		break;
	  }
	}
  }

  renderSettings() {
	return ImageBlock.tunes.map(tune => ({
	  ...tune,
	  label: this.api.i18n.t(tune.label),
	  toggle: true,
	  isActive: !!this.data[tune.name],
	  onActivate: () => this.tuneToggled(tune.name),
	}))
  };

  tuneToggled(tuneName) {
	this.setTune(tuneName, !this._data[tuneName]);
  }

  setTune(tuneName, value) {
	this._data[tuneName] = value;

	let tuneClass = tuneName
	  .replace(/([A-Z])/g, (g) => `-${g[0].toLowerCase()}`);

	this.nodes.imageContainer.classList.toggle(tuneClass, value);
  }

  get data() {
	return this._data;
  }
  set data(data) {
	this._data = Object.assign({}, this.data, data);

	if (this.nodes.imageElement) {
	  this.nodes.imageElement.src = this.data.url;
	}
  }

}